/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';


const mock = [
   {
    description:
      'Eco Club Class 1',
    href : '/leaf-imprint-2025'
 
  },
  {
    description:
      'Eco Club Class 2',
    href : '/plant-seed-2025'
 
  },
  {
    description:
      'Eco Club Class 3',
    href : '/creative-writing-2025'
 
  },
   {
    description:
      'Eco Club Class 4',
    href : '/eco-club-class4-2025'
 
  },
   {
    description:
      'Eco Club Class 5',
    href : '/eco-club-class5-2025'
 
  },
  {
    description:
      'Eco Club Class 6',
    href : '/role-play-2025'
  },
  {
    description:
      'Eco Club Class 7',
    href : '/pen-making-2025'
 
  },
  {
    description:
      'Eco Club Class 8',
    href : '/eco-club-class8-2025'
 
  }
];

const EcoClub2025 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        Eco Club 2025-26
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href = {item.href}>
                <Typography component={'P'}>
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
     
    </Box>

  );
};

export default EcoClub2025;
